// extracted by mini-css-extract-plugin
export default {"ScreenSizeLayout":"ScreenSizeLayout_ScreenSizeLayout__JaSyR","header":"ScreenSizeLayout_header__kP3in","screenSizePage":"ScreenSizeLayout_screenSizePage__bmqiL"};